'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroSnackbar = require('./NitroSnackbar');

var _NitroSnackbar2 = _interopRequireDefault(_NitroSnackbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroSnackbar2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-snackbar/index.js
// module id = 509
// module chunks = 4